define('../app/fukit/configuration/layout.configuration',['require','exports','module','underscore','../view/app.layout.view','!domReady'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
      AppLayout = require('../view/app.layout.view');

  // added to make sure document.body exists
  require('!domReady');

  var LayoutConfiguration = {
    radioRequests: {
      'layoutConfiguration layout': 'layout',
    },

    radioEvents: {
      'app configure': 'onAppConfigure',
      'app before:ready': 'onAppBeforeReady',
    },

    layout: new AppLayout({ el: document.body }),

    onAppConfigure: function(app) {
      app.layout = this.layout;
    },

    onAppBeforeReady: function() {
      this.layout.render();
    },
  };
  module.exports = LayoutConfiguration;
});

